export default {
  dashboard: {
    icon: require("@/assets/i/white/icon-dashboard.svg"),
    iconHover: require("@/assets/i/gray/icon-dashboard.svg"),
    titleEs: "Dashboard",
    titleEn: "Dashboard",
    to: "/dashboard"
  },
  inbound: {
    icon: require("@/assets/i/white/icon-recepcion-w.svg"),
    iconHover: require("@/assets/i/gray/icon-recepcion.svg"),
    titleEs: "Órdenes de aprovisionamiento",
    titleEn: "Provider orders",
    children: [
      {
        titleEs: "Compras",
        titleEn: "Orders",
        to: "/inbound/",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Devoluciones",
        titleEn: "Provider returns",
        to: "/inbound/returns",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Agregar orden de compra",
        titleEn: "Add purchase order",
        to: "/inbound/order/add",
        roles: [1, 2, 3]
      }
    ]
  },
  outbound: {
    icon: require("@/assets/i/white/icon-online.svg"),
    iconHover: require("@/assets/i/gray/icon-online.svg"),
    titleEs: "Expediciones",
    titleEn: "Expeditions",
    children: [
      {
        titleEs: "Dashboard",
        titleEn: "Dashboard",
        to: "/online/",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Devoluciones",
        titleEn: "Sale returns",
        to: "/outbound/returns",
        icon: require("@/assets/i/workflow.png"),
        iconHover: require("@/assets/i/workflowLime.png")
      },
      {
        titleEs: "Agregar orden de online",
        titleEn: "Add online order",
        to: "/online/order/add",
        roles: [1, 2, 3]
      }
    ]
  },
  movements: {
    icon: require("@/assets/i/white/icon-entradas-salidas-w.svg"),
    iconHover: require("@/assets/i/gray/icon-entradas-salidas.svg"),
    titleEs: "Movimientos",
    titleEn: "Movements",
    children: [
      {
        titleEs: "Salida",
        titleEn: "Departure",
        to: "/movements/"
      },
      {
        titleEs: "Entrada",
        titleEn: "Entry",
        to: "/movements/entry/"
      },
      {
        titleEs: "Agregar orden de movimiento",
        titleEn: "Add movement order",
        to: "/movements/order/add",
        roles: [1, 2, 3]
      }
    ]
  },
  inventory: {
    icon: require("@/assets/i/white/icon-inventario.svg"),
    iconHover: require("@/assets/i/gray/icon-inventario.svg"),
    titleEs: "Inventario",
    titleEn: "Inventory",
    children: [
      {
        titleEs: "Recuento",
        titleEn: "Count",
        to: "/inventory/"
      },
      {
        titleEs: "Importar inventario con archivo",
        titleEn: "Import file inventory",
        to: "/inventory/upload_csv/",
        roles: [1, 2, 3]
      }
      // {
      //   titleEs: "Stock",
      //   titleEn: "Stock",
      //   to: "/inventory/stocks/",
      //   icon: require("@/assets/i/workflow.png"),
      //   iconHover: require("@/assets/i/workflowLime.png")
      // },
      // {
      //   titleEs: 'Palés',
      //   titleEn: 'Palés',
      //   to: '/inventory/boxstocks/',
      //   icon: require('@/assets/i/workflow.png'),
      //   iconHover: require('@/assets/i/workflowLime.png')

      // }
    ]
  },
  pos: {
    icon: require("@/assets/i/white/icon-tpvpos-w.svg"),
    iconHover: require("@/assets/i/gray/icon-tpvpos.svg"),
    titleEs: "Punto de venta",
    titleEn: "Point of sale",
    children: [
      {
        titleEs: "Devoluciones",
        titleEn: "Returns",
        to: "/pos",
      },
      {
        titleEs: "Ventas",
        titleEn: "Sales",
        to: "/pos/exits",
      }
    ]
  },

  stock: {
    icon: require("@/assets/i/white/stock-w.svg"),
    iconHover: require("@/assets/i/gray/stock.svg"),
    titleEs: "Stock",
    titleEn: "Stock",
    children: [
      {
        titleEs: "Stock",
        titleEn: "Stock",
        to: "/stock/",
      },
      {
        titleEs: "Stock por EPC",
        titleEn: "EPC stock",
        to: "/epc-stock/",
      }
    ]
  },
  trace_epc: {
    icon: require("@/assets/i/white/epc-track-w.svg"),
    iconHover: require("@/assets/i/gray/epc-track.svg"),
    titleEs: "Trazabalidad EPC",
    titleEn: "EPC trazability",
    children: [
      {
        titleEs: "Trazabalidad EPC",
        titleEn: "EPC trazability",
        to: "/track-epc",
      }
    ]
  },
  workflow: {
    icon: require('@/assets/i/white/free-w.svg'),
    iconHover: require('@/assets/i/gray/free.svg'),
    titleEs: 'Lecturas libres',
    titleEn: 'Free reads',
    children: [{
      titleEs: 'Lecturas libres',
      titleEn: 'Free reads',
      to: '/free-scan', // to: '/workflow/inbound',
    }
    ]
  },
  support: {
    icon: require("@/assets/i/white/support-w.svg"),
    iconHover: require("@/assets/i/gray/support.svg"),
    titleEs: "Support",
    titleEn: "Support",
    to: "/support"
  }
};
